var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-category-links" }, [
    _c("h5", { class: _vm.$mq === "mobile" ? "h4" : "" }, [
      _vm._v(_vm._s(_vm.categoryLinks.heading))
    ]),
    _vm.categoryLinks.links && _vm.categoryLinks.links.length
      ? _c(
          "div",
          {
            staticClass: "collection-category-links__link-container",
            class: _vm.categoryLinks.links.length <= 2 ? "center" : ""
          },
          _vm._l(_vm.categoryLinks.links, function(link, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "collection-category-links__link",
                attrs: { href: link.url }
              },
              [
                _c("span", [_vm._v(_vm._s(link.text))]),
                _c("Icon", {
                  staticClass: "icon",
                  attrs: { name: "arrow-right", size: "24px" }
                })
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }